import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AppService } from '../../store/app.service';
import { CampaignsApiService } from './campaigns.apiservice';
import { TranslateService } from '@ngx-translate/core';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';

@Injectable()
export class CampaignsService {

    constructor(
        private modalService: NgbModal,
        private appService: AppService,
        private campaignService: CampaignsApiService,
        private router: Router,
        private translate: TranslateService
    ) { }

    openEditCampaignModal(options: { campaignId?: string | null; clientId?: string | null } = {}): NgbModalRef {
        const modalRef = this.modalService.open(EditCampaignComponent, {
            size: 'xl',
            backdrop: 'static',
            scrollable: true,
        });

        modalRef.componentInstance.iCampaignId = options.campaignId ?? null;
        modalRef.componentInstance.iClientId = options.clientId ?? null;

        return modalRef;
    }

    deleteCampaign() {
        var d = this.appService.getActiveRoute$().value.url.split('/');
        var cId = d[d.length - 1];
        Swal.fire({
            title: this.translate.instant('ARE_YOU_SURE'),
            text: this.translate.instant('CANNOT_REVERT_ACTION'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translate.instant('YES_DELETE_IT'),
            cancelButtonText: this.translate.instant('CANCEL')
        }).then((result) => {
            if (result.isConfirmed) {
                this.campaignService.deleteCampaign([cId])
                    .subscribe((r: any) => {
                        if (r.good) {
                            this.router.navigate(['/pages/campaigns']);
                        }
                    })
            }
        })
    }

}
